import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appOnlyPositiveNumbers]',
  standalone: true // Mark the directive as standalone
})
export class OnlyPositiveNumbersDirective {
  constructor(private el: ElementRef) {}

  /**
   * Listen for input events to sanitize the value.
   */
  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    let value = inputElement.value;

    // Remove invalid characters (non-numeric or negative signs)
    value = value.replace(/[^0-9]/g, ''); // Allow only digits (0-9)

    // Update the input value
    inputElement.value = value;
  }

  /**
   * Listen for keydown events to prevent invalid keystrokes.
   */
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace',
      'Tab',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Home',
      'End'
    ];

    // Allow numeric keys (0-9) and special keys
    if (
      !allowedKeys.includes(event.key) &&
      !(event.key >= '0' && event.key <= '9')
    ) {
      event.preventDefault();
    }
  }

  /**
   * Listen for paste events to sanitize pasted content.
   */
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    event.preventDefault(); // Prevent default paste behavior

    // Get the pasted text
    const pastedText = event.clipboardData?.getData('text/plain') || '';

    // Sanitize the pasted text (allow only digits)
    const sanitizedValue = pastedText.replace(/[^0-9]/g, '');

    // Insert the sanitized value into the input field
    const inputElement = this.el.nativeElement as HTMLInputElement;
    inputElement.value = sanitizedValue;
  }
}